<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg4 pr-6 pl-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedStartDateFormatted" label="Từ ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title
                                @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedEndDateFormatted" label="Đến ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
                <v-flex lg12>
                    <v-data-table hide-default-footer :items="display_summary" :server-items-length="display_summary ? display_summary.length : 0" :must-sort="true" :loading="loading" :mobile-breakpoint="100" class="summary-table">
                        <template v-slot:header>
                            <thead class="v-data-table-header">
                                <tr>
                                    <th role="columnheader" class="text-start">
                                        <span>Số tài khoản</span>
                                    </th>
                                    <template v-for="bank in config_banks">
                                        <th role="columnheader" class="text-end"  v-bind:key="'th'+bank.value">
                                            <span>{{bank.name}}</span>
                                        </th>
                                    </template>
                                    <th role="columnheader" class="text-end">
                                        <span>Tổng</span>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:item="{ item }">
                            <tr>
                                <td v-if="item.ActionType == -1">Tồn đầu kỳ</td>
                                <td v-else-if="item.ActionType == 99">Tồn cuối kỳ</td>
                                <td v-else>{{ item.ActionType | display_value(action_types) }} trong kỳ</td>
                                <template v-for="bank in config_banks">
                                    <td class="text-end" v-bind:key="'td'+bank.value">{{ item[bank.name] | currency('¥', 2)}}</td>
                                </template>
                                <td class="text-end">{{ item['Total'] | currency('¥', 2)}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
                <v-flex lg12>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :items="items" :headers="headers" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item, index }">
                            <tr>
                                <td>{{ (index + 1) }}</td>
                                <td>{{ item.ReportDate | display_date('DD-MM-YYYY') }}</td>
                                <td>{{ item.ActionType | display_value(action_types) }}</td>
                                <td class="text-end">{{ item.Amount | currency('¥', 2) }}</td>
                                <td>{{ item.BankName }}</td>
                                <td>{{ item.FeeTypeName }}</td>
                                <td>{{ item.Content }}</td>
                                <td v-if="adminRole || interalControlRole || ((storeRole || paymentRole) && compare_date(item.CreatedDate))">
                                    <v-edit-dialog :return-value.sync="item.OrderCodeCN" large lazy persistent @save="saveItem({'ID': item.ID, 'OrderCodeCN': item.OrderCodeCN})">
                                        <div>{{ item.OrderCodeCN }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.OrderCodeCN" label="Mã đặt hàng TQ" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else>{{ item.OrderCodeCN }}</td>
                                <td v-if="adminRole || interalControlRole || ((storeRole || paymentRole) && compare_date(item.CreatedDate))">
                                    <v-edit-dialog :return-value.sync="item.TransactionCode" large lazy persistent @save="saveItem({'ID': item.ID, 'TransactionCode': item.TransactionCode})">
                                        <div>{{ item.TransactionCode }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.TransactionCode" label="Mã vận đơn" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else>{{ item.TransactionCode }}</td>
                                <td>{{ item.Username }}</td>
                                <td>{{ item.OrderCode }}</td>
                                <td class="text-center" v-if="adminRole || interalControlRole || paymentRole"><v-checkbox primary hide-details v-model="item.Status" @change="saveItem({'ID': item.ID, 'Status': item.Status})" :disabled="!(adminRole || interalControlRole || compare_date(item.CreatedDate))"></v-checkbox></td>
                                <td v-if="storeRole">{{ item.Status == 1 ? 'Đã xử lý' : 'Chưa xử lý' }}</td>
                                <td class="text-center">
                                    <v-icon v-if="adminRole || interalControlRole || compare_date(item.CreatedDate)" :disabled="!(adminRole || interalControlRole || paymentRole)" medium class="mr-2" @click="openDetail(item)">fa-edit</v-icon>
                                    <v-icon v-if="adminRole || interalControlRole || compare_date(item.CreatedDate)" :disabled="!(adminRole || interalControlRole || paymentRole)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary_line">
                            <tr class="total-summary-td">
                                <td class="font-weight-bold" colspan="3">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ summary_line.TotalAmount | currency('¥', 2) }}</td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialogUpdate" persistent max-width="700px">
            <v-card>
                <v-card-title>
                    <span class="title">Lệnh thu/chi</span>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap pa-3>
                        <v-flex lg6 md6 sm6>
                            <v-select label="Nghiệp vụ" class="input-group--focused" :items="action_types" v-model="currentItem.ActionType" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg6 md6 sm6>
                            <mh-date-picker plabel="Ngày thu/chi" class="input-group--focused date-picker px-3" v-model="report_date" @onChangeDate="report_date =$event"></mh-date-picker>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <h-currency-input v-model="currentItem.Amount" :decimal="2" label="Số tiền" class="input-group--focused"></h-currency-input>
                        </v-flex>
                        <v-flex lg6 md6 sm6>
                            <v-select label="Số tài khoản" class="input-group--focused" :items="config_banks" v-model="currentItem.Bank" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg6 md6 sm6>
                            <v-select label="Hình thức" class="input-group--focused" :items="config_feetypes" v-model="currentItem.FeeType" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <v-textarea rows="3" v-model="currentItem.Content" label="Nội dung" class="input-group--focused"></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" dark @click="dialogUpdate = false">Đóng</v-btn>
                    <v-btn color="blue darken-1" dark @click="saveDetail(currentItem)">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
import Filtering from "@/components/Filtering";
import MHDatePicker from "@/components/daterange/MHDatePicker";
export default {
    components: {
        "hpo-filter": Filtering,
        "mh-date-picker": MHDatePicker
    },
    data() {
        return {
            dialogUpdate: false,
            action_types: [
                {value: 0, name: 'Thu'},
                {value: 1, name: 'Chi'},
            ],
            viewName: "bao-cao-thu-chi-tien-yuan",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            pagination: {...configs.PAGINATION, sortBy: ["ReportDate"], sortDesc: [true]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            currentItem: {},
            report_date: null,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.reportMoneyYuan.all.data,
            summary: state => state.reportMoneyYuan.summary.summary,
            last_time: state => state.reportMoneyYuan.summary.last_time,
            summary_line: state => state.reportMoneyYuan.all.summary,
            total_rows: state => state.reportMoneyYuan.all.total,
            configuration: state => state.configuration.selected,
            loading: state => state.reportMoneyYuan.loading
        }),
        headers(){
            return [
                {
                    text: "STT",
                    filterable: false,
                    dataType: configs.DATA_TYPE['Number']
                },
                {
                    text: "Ngày",
                    value: "ReportDate",
                    filterable: true,
                    width: 120,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Nghiệp vụ",
                    value: "ActionType",
                    filterable: true,
                    values: this.action_types,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số tài khoản",
                    value: "Bank",
                    filterable: true,
                    values: this.config_banks,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Hình thức",
                    value: "FeeType",
                    filterable: true,
                    values: this.config_feetypes,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Nội dung",
                    value: "Content",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã đặt hàng TQ",
                    value: "OrderCodeCN",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã đơn",
                    value: "OrderCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: [
                        {value: 0, name: 'Chưa xử lý'},
                        {value: 1, name: 'Đã xử lý'},
                    ],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "",
                    width: 100
                }
            ];
        },
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        interalControlRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl;
        },
        storeRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
        },
        config_banks() {
            return this.configuration.ReExBanks ? JSON.parse(this.configuration.ReExBanks) : [];
        },
        config_feetypes() {
            return this.configuration.ReExFeeTypes ? JSON.parse(this.configuration.ReExFeeTypes) : [];
        },
        display_summary() {
            if(!this.$store.state.reportMoneyYuan.summary.summary || this.$store.state.reportMoneyYuan.summary.summary == undefined) {
                return [];
            }
            let summary = [...this.$store.state.reportMoneyYuan.summary.summary];
            let in_come = _.find(this.$store.state.reportMoneyYuan.summary.last_time, {'ActionType': 0});
            let out_come = _.find(this.$store.state.reportMoneyYuan.summary.last_time, {'ActionType': 1});
            let begin = {'ActionType': -1};
            for (let i = 0; i < this.config_banks.length; i++) {
                const bank = this.config_banks[i];
                begin[bank.name] = (in_come == undefined ? 0 : in_come[bank.name]) - (out_come == undefined ? 0 : out_come[bank.name]);
            }
            begin['Total'] = (in_come == undefined ? 0 : in_come['Total']) - (out_come == undefined ? 0 : out_come['Total']);
            summary.unshift(begin);

            let end = {'ActionType': 99};
            let first = _.find(summary, {'ActionType': -1});
            in_come = _.find(summary, {'ActionType': 0});
            out_come = _.find(summary, {'ActionType': 1});
            for (let i = 0; i < this.config_banks.length; i++) {
                const bank = this.config_banks[i];
                end[bank.name] = ((first == undefined ? 0 : first[bank.name]) || 0) + ((in_come == undefined ? 0 : in_come[bank.name]) || 0) - ((out_come == undefined ? 0 : out_come[bank.name]) || 0);
            }
            end['Total'] = ((first == undefined ? 0 : first['Total']) || 0) + ((in_come == undefined ? 0 : in_come['Total']) || 0) - ((out_come == undefined ? 0 : out_come['Total']) || 0);
            summary.push(end);
            return summary;
        }
    },
    methods: {
        applyFilter(filterConditions) {
            this.pagination = {
                ...configs.PAGINATION,
                sortBy: this.pagination.sortBy,
                sortDesc: this.pagination.sortDesc
            };
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("reportMoneyYuan/getList", param);
            this.$store.dispatch("reportMoneyYuan/getSummary", {filter: [{ column: "ReportDate", value: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), condition: "d_greater_than_or_equal"},
            { column: "ReportDate", value: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT), condition: "d_less_than_or_equal"}
            ]});
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.adminRole || this.paymentRole)});
        },
        openDetail(item) {
            this.dialogUpdate = true;
            this.currentItem = item;
            this.report_date = this.currentItem.ReportDate ? moment(this.currentItem.ReportDate).toISOString().substr(0, 10) : null;
        },
        deleteItem(id) {
            window.getApp.$emit("REQUEST_DELETE_DATA", id);
        },
        saveItem(item) {
            this.$store.dispatch("reportMoneyYuan/setDetail", {
                id: item.ID,
                data: {
                    ...item
                }
            });
        },
        saveDetail(item) {
            const bank = _.find(this.config_banks, {'value': item.Bank})
            const feetype = _.find(this.config_feetypes, {'value': item.FeeType})
            this.$store.dispatch("reportMoneyYuan/setDetail", {
                id: item.ID,
                data: {
                    ...item,
                    BankName: bank ? bank.name : '',
                    FeeTypeName: feetype ? feetype.name : '',
                    ReportDate: this.report_date ? moment(this.report_date, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
                }
            });
            this.dialogUpdate = false;
        },
        createData() {
            this.currentItem = {
                ID: 0,
                ActionType: 0,
                Amount: 0,
            };
            this.dialogUpdate = true;
        },
        compare_date(createdDate) {
            const createdDateMoment = moment(createdDate).format('YYYY-MM-DD');
            const currentDateMoment = moment().format('YYYY-MM-DD');
            return !moment(currentDateMoment).isAfter(createdDateMoment);
        }
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.adminRole || this.paymentRole)});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("reportMoneyYuan/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
<style scoped>
.summary-table {
    border-bottom: 1px solid #d3d5d6;
}
</style>